import React from "react";
import SideMenu from "./SideMenu";
import { buildLoanAccountMenuItems } from "./menuItems";

const LoanAccountSideMenu = () => {
  return <SideMenu sideMenuItems={buildLoanAccountMenuItems("/loan-account")} />;
};

export default LoanAccountSideMenu;
